export const init = () => {

  const startLazyLoadingVideo = () => {
    const videos = document.querySelectorAll('video:not([data-video-loaded])');

    const lazyLoadVideo = (video) => {
      if (video.hasAttribute('data-video-loaded')) return;

      const sources = video.querySelectorAll('source');
      sources.forEach(source => {
        source.src = source.getAttribute('data-src');
      });

      video.load();

      video.addEventListener('loadeddata', () => {
        video.setAttribute('data-video-loaded', 'true');
        video.play();
      }, { once: true });

      // BANNER D  
      if (video?.closest('.content')?.querySelector('.js-banner-d-wrapper')) {
        video.removeAttribute('loop');

        video.addEventListener('ended', () => {
          video.closest('.content').querySelector('.js-banner-d-wrapper').classList.add("js-fade-in");
        });
      }

    };



    const videoObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          lazyLoadVideo(entry.target);
          observer.unobserve(entry.target);
        }
      });
    });

    videos.forEach(video => {
      videoObserver.observe(video);
    });
  }

  startLazyLoadingVideo();


  const observer = new MutationObserver(() => {
    startLazyLoadingVideo();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}




